export default function PrivacyPolicy() {
  return (
    <div style={{ background: '#0a0a0a', minHeight: '100vh', fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif", color: '#ffffff', padding: '40px 20px' }}>
      <div style={{ maxWidth: '680px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '32px', borderBottom: '1px solid #2a2a2a' }}>
          <div style={{ fontSize: '28px', fontWeight: '900', letterSpacing: '.15em', textTransform: 'uppercase' }}>WOW FACTOR</div>
          <div style={{ fontSize: '11px', color: '#555', letterSpacing: '.2em', textTransform: 'uppercase', marginTop: '4px' }}>Baseball Training &amp; Development</div>
        </div>

        <h1 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>Privacy Policy</h1>
        <p style={{ color: '#666', fontSize: '13px', marginBottom: '32px' }}>Effective date: April 21, 2026</p>

        <Section title="1. Overview">
          Wow Factor Baseball (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) operates the Wow Factor Baseball training scheduling platform at wowfactortraining.com. This Privacy Policy explains what information we collect, how we use it, and your choices — including how to opt out of SMS notifications.
        </Section>

        <Section title="2. Information We Collect">
          When you create an account, we collect your first and last name, email address, and optionally your phone number. We also collect information about training sessions you book or participate in.
        </Section>

        <Section title="3. SMS Text Message Notifications">
          <p style={{ marginBottom: '12px' }}>If you provide a phone number and check the SMS opt-in box during registration, you consent to receive transactional SMS text messages from Wow Factor Baseball. These messages include:</p>
          <ul style={{ color: '#a0a0a0', lineHeight: '1.8', paddingLeft: '20px', marginBottom: '12px' }}>
            <li>Session booking confirmations</li>
            <li>Session reschedule and cancellation alerts</li>
            <li>24-hour session reminders</li>
          </ul>
          <p style={{ marginBottom: '8px' }}><strong>We do not send marketing or promotional SMS messages.</strong></p>
          <p style={{ marginBottom: '8px' }}>Message frequency varies based on your booking activity. Message and data rates may apply.</p>
          <p><strong>To opt out:</strong> Reply STOP to any message, or log in to your account and uncheck SMS Notifications in your profile settings. After opting out, you will receive a final confirmation message and no further SMS messages will be sent.</p>
        </Section>

        <Section title="4. How We Use Your Information">
          We use your information solely to operate the platform — scheduling sessions, sending session notifications, and providing account support. We do not sell or share your personal information with third parties for marketing purposes.
        </Section>

        <Section title="5. Third-Party Services">
          We use Twilio to deliver SMS messages. Twilio may process your phone number in accordance with their own privacy policy. We use email service providers to deliver email notifications.
        </Section>

        <Section title="6. Data Retention">
          Your account information is retained for as long as your account is active. You may contact us to request deletion of your account and associated data.
        </Section>

        <Section title="7. Contact Us">
          If you have questions about this Privacy Policy or wish to manage your data, contact us at:{' '}
          <a href="mailto:support@wowfactortraining.com" style={{ color: '#60a5fa' }}>support@wowfactortraining.com</a>
        </Section>

        <div style={{ borderTop: '1px solid #1e1e1e', marginTop: '40px', paddingTop: '24px', textAlign: 'center' }}>
          <p style={{ color: '#444', fontSize: '12px', margin: 0 }}>
            <a href="/register" style={{ color: '#60a5fa', textDecoration: 'none' }}>Back to Registration</a>
            {' · '}
            <a href="/terms" style={{ color: '#60a5fa', textDecoration: 'none' }}>Terms &amp; Conditions</a>
            {' · '}
            <a href="/login" style={{ color: '#60a5fa', textDecoration: 'none' }}>Sign In</a>
          </p>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '28px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '10px', color: '#ffffff' }}>{title}</h2>
      <div style={{ color: '#a0a0a0', fontSize: '14px', lineHeight: '1.7' }}>{children}</div>
    </div>
  );
}
